<div class="model-viewer-container">
    <model-viewer *ngIf="component.data.url" alt="{{component.data.alt}}" src="{{component.data.url}}" ar id="modelviewer-{{component.id}}"
        [attr.environment-image]="component.data.environmentImage ? component.data.environmentImage : null"
        [attr.skybox-image]="component.data.skyboxImage ? component.data.skyboxImage : null"
        [attr.poster]="component.data.poster ? component.data.poster : null"
        [attr.shadow-intensity]="component.data.shadowIntensity != undefined ? +component.data.shadowIntensity / 100 : 1"
        camera-controls touch-action="pan-y"
        [attr.animation-name]="component.data.animationName ? component.data.animationName : null"
        [attr.autoplay]="component.data.animationAutoplay ? true : null"></model-viewer>
</div>